<script>
import {mapActions, mapState} from "pinia";
import Dialog from "primevue/dialog";
import {errorsStore} from "@/store/errorsStore";

export default {
  name: "BaseErrorModal",
  components: {
    Dialog
  },
  computed: {
    ...mapState(errorsStore, [
        'errorModalState',
        'errorData'
    ]),
    modalState: {
      get() {
        return this.errorModalState;
      },
      set() {
        this.closeModal();
      },
    },
    hasErrorText() {
      return this.errorData && this.errorData.message;
    }
  },
  methods: {
    ...mapActions(errorsStore, [
      'showErrorModal',
      'hideErrorModal'
    ]),
    closeModal() {
      this.hideErrorModal();
    }
  }
}
</script>

<template>
  <Dialog v-model:visible="modalState"
          class="error-modal"
          modal
          :header="$t('errors.somethingWentWrong')"
  >
    <div>
      <p v-if="hasErrorText" class="mb-10">{{errorData.message}}</p>
      <p>
        {{$t('errors.errorModalText.p1')}}
        <a href='mailto:bugs@peoplepolitics.com'>bugs@peoplepolitics.com</a>
        {{$t('errors.errorModalText.p2')}}
      </p>
    </div>
    <template #footer>
      <button type="button" class="p-dialog-close-btn" @click="closeModal()">
        {{$t('common.buttons.close')}}
      </button>
    </template>
  </Dialog>
</template>

<style lang="scss">
.error-modal {
  width: 500px;

  .p-dialog-content {
    padding: 23px 32px;
    font-size: 12px;
    line-height: 16px;
  }
}
</style>